/** @format */

import {useState} from 'react';
import dot from 'dot-object';
import {parseEntityError} from 'frontier-form';
import SuperAgent from 'superagent';
import {validatePassword} from 'frontier/utilities/password_validator';
import {parsePhoneValue, parseValue} from 'frontier/components/form/handle_change';

export default function useNewAccount({onLogin = false, redirect = false} = {}) {
    const [state, setState] = useState({
        full_name: '',
        email: '',
        company: '',
        phone: '',
        password: '',
        isSubmitting: false,
        error: false
    });

    const handleSubmit = async () => {
        setState({...state, isSubmitting: true, error: false});
        try {
            const response = await SuperAgent.post('/account/users/register')
                .set('Accept', 'application/json')
                .send({
                    full_name: state.full_name,
                    email: state.email,
                    company: state.company,
                    phone: state.phone,
                    password: state.password
                })
                .query({
                    redirect: redirect
                });

            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push({
                    event: 'sign_up'
                });
            }

            if (!onLogin) {
                window.location.assign(response.body.redirect);
            } else {
                onLogin({
                    redirect: response.body.redirect,
                    isLoggedIn: true,
                    userId: response.body.id
                });
            }
        } catch (e) {
            setState({
                ...state,
                isSubmitting: false,
                error: parseEntityError(dot.pick('response.body', e))
            });
        }
    };

    return {
        ...state,
        isComplete: () => {
            const {full_name, email, phone, password} = state;
            const {passesValidation} = validatePassword(password);

            const isfullNameFilled = full_name !== '' && full_name !== undefined,
                isEmailFilled = email !== '' && email !== undefined,
                isPhoneFilled = phone !== '' && phone !== undefined,
                isPasswordFialled = password !== '' && password !== undefined;

            if (
                isfullNameFilled &&
                isEmailFilled &&
                isPhoneFilled &&
                isPasswordFialled &&
                passesValidation
            )
                return true;
            return false;
        },
        onKeyPress: e => {
            if (e.keyCode === 13) {
                handleSubmit();
            }
        },
        onSubmit: handleSubmit,
        onInputChange: (field, e) => {
            let value = parseValue(e);
            if (field === 'phone') {
                value = parsePhoneValue(value);
            }

            setState({...state, [field]: value});
        }
    };
}
